export const API_ENDPOINT = "https://testapi.includere.co/api/v1/";
